<template>
  <div class="row p-0 mb-5">

    <!-- Date Filters  --> 
    <!-- falta hacer funcionar el back de los dtp -->
     <div class="col-12 px-0 mx-0">

        <div class="row mx-1 py-2">    

          <!-- Date from    -->
          <div class="col-12  col-md-2">
            <date-picker
              id="startDatePicker"
              class=""
              v-model="range.startDate"
              :config="datePickerConfig"
              placeholder="Start Date"
            />
          </div>

          <!-- Date to    -->
          <div class="col-12 col-md-2">
            <date-picker
              id="endDatePicker"
              class=""
              v-model="range.endDate"
              :config="datePickerConfigEndDate"
              placeholder="End Date"
            />
          </div>

          <!-- Button action filter -->
          <div class="col-12 col-md-2">
            <button
              class="btn btn-success"
              @click=" getDataStats(false)"
              style="width: 100%"
            >
              <i class="icon-calendar-check-o mr-2"></i>
              <small> {{ $t("lang.button.filter") }} </small>
            </button>
          </div>
      </div>
     </div>
    

    <!-- Graphic -->
    <div class="col-12 p-2 mb-2">
      <div class="card" v-if="currentUser.plan_id != '5'">
        <!-- <h6 class="my-2 ml-2 font-weight-bold">
          {{ $t("lang.label.meetingBooked") }} 
          ( {{ $t("lang.label.last30Days") }})
        </h6> -->
        <!-- <div class="col-md-12" v-if="!loadingChartData"> -->
          <line-chart 
          :class="timechart == 'day' ? 'd-block' : 'd-none'"    
          v-if="!loadingStats"                   
          :width="300"
          :height="100" 
          :chart-data="multiaxis" 
          :options="multiaxis.options"        
          :keyChart="keyChart"
          />
        <!-- </div> -->
        <div class="d-flex justify-content-center align-items-center" style="height: 300px" v-else>
          <Loadingcircle :paramloading="paramloading" />
        </div>
      </div>
      <div class="card" v-if="currentUser.plan_id == '5'">
          
          <div class="col-md-12" v-if="!loadingChartData">
            <MonitorBarChart   
              :keyChart="keyChart"          
              :title="chartInfo.title"
              :range="range"
              :method="chartInfo.name"
              :userId="1" 
              :planId="'5'"     
            />
          </div>
          
        
          <div class="d-flex justify-content-center align-items-center" style="height: 300px" v-else>
            <Loadingcircle :paramloading="paramloading" />
          </div>
      </div>
    </div>

    <!-- Details -->
    <!-- <div class="col-12 col-md-6 p-2">
      <div class="card border my-0 py-0 px-2">

        <div class=" mt-2 mb-4 h5 pt-3 px-4">

          <div class="row d-flex align-items-center flex-column flex-md-row ">
            <div class="col-12 col-sm-6 col-md-4 col-lg-2 px-0 my-1 text-right mb-1 mb-md-0 ">
              <Loadingcircle :paramloading="paramloading" v-if="loadingTotals" />
              <span class="h5 text-primary" v-else> {{ totals.newContactsAddressed }} </span>
            </div>
            <div class="col-12 col-sm-6 col-md-8 col-lg-10">
              {{ $t("lang.label.newContactsAddressed") }}
            </div>
          </div>

          <div class="row d-flex align-items-center flex-column flex-md-row" v-if="currentUser.plan_id == '5'">
            <div class="col-12 col-sm-6 col-md-4 col-lg-2 px-0 my-1 text-right mb-1 mb-md-0 ">
              <Loadingcircle :paramloading="paramloading" v-if="loadingTotals" />
              <span class="h5 text-primary" v-else> {{ totals.tasksVerified }} </span>
            </div>
            <div class="col-12 col-sm-6 col-md-8 col-lg-10">
              {{ this.$t("lang.label.header_booker_ver_tks")}}
            </div>
          </div>


          <div class="row d-flex align-items-center flex-column flex-md-row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-2 px-0 my-1 text-right mb-1 mb-md-0 ">
              <Loadingcircle :paramloading="paramloading" v-if="loadingTotals" />
              <span class="h5 text-primary" v-else>{{ totals.followUpEmails }}</span>
            </div>
            <div class="col-12 col-sm-6 col-md-8 col-lg-10">
              <h5>{{ $t("lang.label.followUpEmails") }}</h5>
            </div>
          </div>

          <div class="row d-flex align-items-center flex-column flex-md-row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-2 px-0 my-1 text-right mb-1 mb-md-0 ">
              <Loadingcircle :paramloading="paramloading" v-if="loadingTotals" />
              <span class="h5 text-primary" v-else>{{ totals.ongoingConversations }}</span>
            </div>
            <div class="col-12 col-sm-6 col-md-8 col-lg-10">
              <span class="h5">{{ $t("lang.label.ongoingConversations") }}</span>
              <Tooltip :text="$t('lang.general.ongoing_conversations')" :width="'2'">
                <div class="ml-2 circle-tooltip bg-secondary d-flex align-items-center justify-content-center">
                  <span class="m-0 question-mark text-white">
                    ?
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div class="row d-flex align-items-center flex-column flex-md-row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-2 px-0 my-1 text-right mb-1 mb-md-0 ">
              <Loadingcircle :paramloading="paramloading" v-if="loadingTotals" />
              <span class="h5 text-primary" v-else>{{ totals.meetingsBooked }}</span>
            </div>
            <div class="col-12 col-sm-6 col-md-8 col-lg-10">
              <h5>{{ $t("lang.label.meetingBooked") }}</h5>
            </div>
          </div>

          <div class="col-12 ml-4 my-5 d-flex justify-content-start align-items-center">
            <button class="btn btn-outline-primary ml-2 rounded px-5" @click="goMoreInsigts()">
              <span >{{ $t("lang.label.viewMoreInsights") }}</span>
            </button>
          </div>


        </div>
      </div>
    </div> -->

    <!-- Next meeting -->
    <!-- <div class="col-12 col-md-6 p-2">
      <div class="card">
        <div class="row m-0 p-0">
          <div class="col-12 pt-3 pl-4 pb-4 bg-gradient text-left">
            <img src="@/assets/images/oliver.png" width="30px" class="rounded d-block mb-2 logooliver" />
            <span>
              <h5 class="text-white">
                {{ $t("lang.label.getMoreMeetings") }}
              </h5>
            </span>
            <div class="mt-2">
              <button class="btn btn-outline-light" @click="addOrder">{{ $t("lang.onBoarding.create") }}</button>
            </div>
          </div>

          <div class="pl-4 pt-4 pb-5 " >
            <span class="">
              <h5 class="font-weight-bold mt-4 mb-3">  {{ $t("lang.label.nextMeeting")}} </h5>
            </span>
            <div style="height: 130px" v-if="contactData || !getNextMeetingNoData">
              <p v-if="!contactData">
                <Loadingcircle :paramloading="paramloading" />
              </p>
              <h6 class="font-weight-bold mt-4 mb-3" v-else>
                <span v-if="contactData.company_name && contactData.date_time">{{ contactData.company_name }} - {{ formatDate(contactData.date_time) }}</span>
                <span v-else> - </span>
              </h6>
              <p v-if="!contactData">
                <Loadingcircle :paramloading="paramloading" />
              </p>
              <p class="my-2" v-else>
                <i class="mr-2 icon-user"></i>
                <span v-if="contactData.contact && contactData.contact.first_name && contactData.contact.last_name">
                  {{ contactData.contact.first_name }} {{ contactData.contact.last_name }}
                </span>
                <span v-else> - </span>
              </p>
              <p v-if="!contactData">
                <Loadingcircle :paramloading="paramloading" />
              </p>
              <p class="my-2" v-else>
                <i class="mr-2 icon-video-camera"></i>
                <span v-if="contactData.url">
                  <a 
                  :href="contactData.url" 
                  target="_blank"  
                  class="text-primary" 
                  style="text-decoration: underline;" 
                  rel="noopener noreferrer">{{ $t("lang.label.joinTheMeeting") }}</a>
                </span>
                <span v-else> - </span>
              </p>
              <p v-if="!contactData">
                <Loadingcircle :paramloading="paramloading" />
              </p>
              <p class="my-2" v-else>
                <i class="mr-2 icon-phone"></i>
                <span v-if="contactData.contact && contactData.contact.phone">
                  {{ contactData.contact.phone }}
                </span>
                <span v-else> - </span>
              </p>
            </div>
            <div v-else style="height: 152px">
            </div>
            
            <button class="px-4 btn btn-outline-primary" @click="goOpportunity">
              {{ $t("lang.button.open_opportunity") }}
            </button>

          </div>
        </div>

      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LineChart from "@/components/Chart.vue";
import Loadingcircle from  "@/components/Common/Loadingcircle.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import { targetsService, calendlyService } from '@/_services';
import MonitorBarChart from "@/components/Dashboard/Monitor/Barchart.vue";
import moment from "moment";

export default {
  components: {
    LineChart,
    Loadingcircle,
    Tooltip,
    MonitorBarChart
  },
  computed: {
    ...mapState({
          loadingStats: state => state.campaigns.loadingStats,
          loadingStatsComplete: state => state.campaigns.loadingStatsComplete,
          stats: state => state.campaigns.stats.data,
          currentUser: state => state.authentication.user,
      }),
    user() {
      return this.$store.state.authentication.user;
    },
    formatDate() {
      return (date) => {
        const parsedDate = moment(date);
        // Format the date as "MMM DD - HH:mm"
        const formatted = parsedDate.format('MMM DD - HH:mm');
        return formatted;
      }
    }
  },
  watch: {
    loadingStats: function() {
      this.loadStatsData();
    }
  },
  created() {
    this.getTotals();
    this.getNextMeeting();
    this.getDataStats();
    let opt = this.options;
    this.options.forEach((r, index) => {
      if (r.role.indexOf(this.currentUser.role_id) >= 0) {
        if (r.isDisabled) {
          r.label = r.label + " (coming soon)";
        }
        this.optselect.push(r);
        if (r.id == "meetings") {
          this.filters.type.push(r.id);
        }
      }
    });
  },
  data() {
    return {
      loadingChartData: false,
      keyChart: 1,
      chart2: 200,
      chartInfo: {
          name: "client-task-verified",
          title: this.$t("lang.label.bdr-performance"),
      },      
      labelsComplete: [],
      contactData: null,
      getNextMeetingNoData: false,
      paramloading: {
        width: '28px',
        height: '28px',
        color: '#5054EB'
      },
      paramloadingContactData: {
        width: '78px',
        height: '78px',
        color: '#5054EB'
      },
      loadingTotals: true,
      loadingContactData: true,
      totals: {
        newContactsAddressed: 0,
        followUpEmails: 0,
        ongoingConversations: 0,
        meetingsBooked: 0,
      },
      filters: {
        type: [],
        sendingMethods: [],
        sendingProviders: []
      },

      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      range: {
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },

       options: [
        {
          id: "sent",
          label: "Sent, Bounces",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,100"
        },
        {
          id: "newsent",
          label: "New Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0"
        },
        {
          id: "recurringsent",
          label: "Recurring Sent",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,0,0"
        },
        {
          id: "recurringsent2",
          label: "Step 2",
          role: ["1"],
          isDisabled: false,
          color: "180,140,30"
        },
        {
          id: "recurringsent3",
          label: "Step 3",
          role: ["1"],
          isDisabled: false,
          color: "210,230,20"
        },
        {
          id: "recurringsent4",
          label: "Step 4",
          role: ["1"],
          isDisabled: false,
          color: "180,200,30"
        },
        {
          id: "recurringsent5",
          label: "Step 5",
          role: ["1"],
          isDisabled: false,
          color: "180,130,30"
        },
        {
          id: "recurringsent6",
          label: "Step 6",
          role: ["1"],
          isDisabled: false,
          color: "230,230,120"
        },
        {
          id: "money",
          label: "CA TTC",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0"
        },
        {
          id: "billing",
          label: this.$t("lang.statistics.billing"),
          role: ["1", "5", "6", "7"],
          isDisabled: false,
          color: "28, 4, 219"
        },
        {
          id: "meetings",
          label: this.$t("lang.statistics.generated"),
          role: ["4", "1", "5", "6", "7"],
          isDisabled: false,
          color: "51, 204, 204"
        },
        {
          id: "cashed",
          label: this.$t("lang.statistics.cashed"),
          role: ["1"],
          isDisabled: false,
          color: "122, 169, 81"
        },
        {
          id: "sessions",
          label: this.$t("lang.statistics.session"),
          role: ["1"],
          isDisabled: false,
          color: "45, 138, 131"
        },
        {
          id: "response_rate",
          label: "MAR (Manual Answer Rate)",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0"
        },
        {
          id: "conversion_rate",
          label: "Converstion rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0"
        },
        {
          id: "variance",
          label: "Standard Deviation",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "0,0,0"
        },
        {
          id: "spam_rate",
          label: "Spam rate",
          role: ["1", "5", "6"],
          isDisabled: false,
          color: "255,100,0"
        }
      ],
      multiaxis: {
        labels: [],
        datasets: [],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity")
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "day"
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false
                }
              }
            ]
          }
        }
      },
       multiaxismonth: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(133,43,242,1)",
            backgroundColor: "RGBA(133,43,242,0.51)",
            pointBackgroundColor: "rgba(220,220,220,1)",
            yAxisID: "y2",
            data: []
          }
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity")
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "month"
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false
                }
              }
            ]
          }
        }
      },
      multiaxisweek: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(122,43,242,1)",
            backgroundColor: "RGBA(133,23,242,0.51)",
            pointBackgroundColor: "rgba(110,220,220,1)",
            yAxisID: "y2",
            data: []
          }
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity")
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY"
                  }
                },
                offset: true,
                gridLines: {
                  display: true
                }
              }
            ]
          }
        }
      },
      optselect: [],
      timechart: "day",
      groupedmeetigns: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: []
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: []
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: []
          }
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "day"
                }
              }
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100
                }
              }
            ]
          }
        }
      },
    };
  },

  methods: {
      ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),
    getNextMeeting(){
      this.loadingContactData = true
      calendlyService.getNextMeeting()
        .then( res => {
          if( res ){
            this.contactData = res
            this.getNextMeetingNoData = false;
          } else {
            this.getNextMeetingNoData = true;
          }
          this.loadingContactData = false
        })
    },
    addOrder(index) {
      this.$router.push("/orders/add");
    },
    goOpportunity(id) {
      this.$router.push('/opportunities/' + this.contactData.link_id );
    },
    goMoreInsigts(index) {
      this.$router.push("/activity");
    },
    getTotals(){
      const data = {
        startDate: this.range.startDate,
        endDate: this.range.endDate,
        target_ids: 0,
        last_days: 0,
        non_admin: ( this.user.role_id == '3') ? 1 : 0
      }
      this.loadingTotals = true
      targetsService.getActivitiesForOrder(data)
        .then( res => {
          this.loadingTotals = false
          this.totals.newContactsAddressed = res.new_contact_addressed_total;
          this.totals.followUpEmails = res.follow_ups_total;
          this.totals.ongoingConversations = res.ongoing_conversations_total;
          this.totals.meetingsBooked = res.meeting_booked_total;
          this.totals.tasksVerified = res.tasks_verified_total;
        })
    },

    getDataStats(lastDays = true){
      if(lastDays == false){
        this.getTotals()
        if(this.currentUser.plan_id == '5'){
          this.loadingChartData = true
          setTimeout(() => {
            this.keyChart++
            this.loadingChartData = false
          }, 2000)
          return false
        }        
      } 

      if (
        this.filters.type.indexOf("recurringsent") >= 0 &&
        this.filters.type.indexOf("recurringsent2") < 0
      ) {
        this.filters.type.push("recurringsent2");
        this.filters.type.push("recurringsent3");
        this.filters.type.push("recurringsent4");
        this.filters.type.push("recurringsent5");
        this.filters.type.push("recurringsent6");
        this.optselect.push(this.options["recurringsent2"]);
        this.optselect.push(this.options["recurringsent3"]);
        this.optselect.push(this.options["recurringsent4"]);
        this.optselect.push(this.options["recurringsent5"]);
        this.optselect.push(this.options["recurringsent6"]);
      }

      this.multiaxis.datasets = [];
      this.multiaxisweek.datasets = [];
      this.multiaxismonth.datasets = [];
      this.loadMultiaxis();
      this.meetings_details = [];      

      this.getCampaignStatsByIdAndRange({
          id: 0,
          startDate: this.range.startDate,
          endDate: this.range.endDate,
          client: this.user.client_id,
          last_days: lastDays,
          non_admin: (this.user.role_id == '4') ? false : true,
          filters: [
            "meetings"
          ]
        });
    },
    loadMultiaxis() {
      this.options.forEach((r, index) => {
        if (this.filters.type.indexOf(r.id) >= 0) {
          let type = "bar";
          let yaxis = "y2";

          if (r.id == "answers") {
            yaxis = "y1";
          }

          if (r.id == "meetings") {
            type = "line";
            yaxis = "y1";
          }
          if (r.id == "reprogramming") {
            type = "line";
            yaxis = "y1";
          }
          if (
            r.id == "recurringsent" ||
            r.id == "recurringsent2" ||
            r.id == "recurringsent3" ||
            r.id == "recurringsent4" ||
            r.id == "recurringsent5" ||
            r.id == "recurringsent6"
          ) {
            this.multiaxis.datasets.push({
              type: "bar",
              label: r.label,
              filter: r.id,
              yAxisID: "y2",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              data: []
            });
            this.multiaxis.options.scales.xAxes = [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1
              }
            ];
          } else {
            this.multiaxis.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: []
            });
            this.multiaxisweek.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: []
            });
            this.multiaxismonth.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: []
            });
          }
        }
      });
    },
    completeValuesToArray(labelComplete, labels, data){
      let dataComplete = []
      labelComplete.forEach( el => {
        const indexFindValue = labels.findIndex( e => e === el)
        if(indexFindValue > -1){
          dataComplete.push(data[indexFindValue])
        } else {
          dataComplete.push("0")
        }
      })

      return dataComplete;
    },
    generateDateRange(startDate, endDate) {
      let dates = [];
      let currentDate = moment(startDate)

      while (currentDate.isSameOrBefore(endDate)) {
        const new_date = moment(currentDate);
        dates.push(new_date.format('YYYY-MM-DD'));
        currentDate.add(1, 'days');
      }

      return dates;
    },
    loadStatsData(){
      if (!this.loadingStats) {
          this.multiaxis.datasets.push({
              type: 'line',
              label: 'meetings',
              hidden: false,
              filter: 'meetings',
              borderColor: "RGBA(" + ' 51, 204, 204 ' + ",1)",
              backgroundColor: "RGBA(" + ' 51, 204, 204 ' + ",0.48)",
              pointBackgroundColor: "RGBA(" + ' 51, 204, 204 ' + ",1)",
              yAxisID: 'y1',
              data: []
            });

        const labels = this.stats.activity_by_date.labels;
        const startDate = labels[0];
        const endDate = labels[labels.length - 1];

        //Envio a la funcion la primer y ultima fecha del rango que se solicita en la consulta
        this.labelsComplete = this.generateDateRange(startDate, endDate)
        this.multiaxis.labels = this.labelsComplete
        this.multiaxis.datasets.forEach((r, index) => {

          if( this.multiaxis.datasets[index].filter === 'meetings'){
            const dataComplete = this.completeValuesToArray(
              this.labelsComplete,
              this.stats.activity_by_date.labels,
              this.stats.activity_by_date[this.multiaxis.datasets[index].filter]
            );
            this.multiaxis.datasets[index].data = dataComplete
          }

        });

        this.getMultiaxis();

        this.groupedmeetigns.labels = this.labelsComplete;
        this.groupedmeetigns.datasets[0].label = "Planned %";
        this.groupedmeetigns.datasets[1].label = "Canceled %";
        this.groupedmeetigns.datasets[2].label = "Absent %";
        this.groupedmeetigns.datasets[0].data = this.stats.activity_by_date[
          "planned"
        ];
        this.groupedmeetigns.datasets[1].data = this.stats.activity_by_date[
          "canceled"
        ];
        this.groupedmeetigns.datasets[2].data = this.stats.activity_by_date[
          "absent"
        ];

        // this.getGroupWeek();
        // this.getGroupMonth();
      }
    },
    getMultiaxis() {
      // this.optselect.forEach((r, index) => {
      //   //this.getMultiaxisMonth(r.id);
      //   //this.getMultiaxisWeek(r.id);
      // });
    },

  },
};
</script>

<style scoped>
.circle-tooltip {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  font-size: 11px;
  margin: 0px;
}

.bg-gradient {
    background: linear-gradient(135deg, #212246, #4F51DA);
}
</style>
